export const ADD_PENDING_TRACKS = 'ADD_PENDING_TRACKS'
export const REMOVE_PENDING_TRACKS = 'REMOVE_PENDING_TRACKS'
export const RESET_PRODUCT_TRACKER = 'RESET_PRODUCT_TRACKER'
